<template>
  <div class="card mb-25 border-0 rounded-0 bg-white">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div
        class="mb-15 mb-md-30 d-sm-flex align-items-center justify-content-between"
      >
        <h6 class="card-title fw-bold mb-0">LISTE DES DERNIERES VENTES</h6>
        <!-- <div
          class="card-select mt-10 mt-md-0 mb-10 mb-md-0 d-inline-block d-sm-flex align-items-center ps-10 pe-10 pt-5 pb-5"
        >
          <span class="fw-medium text-muted me-8">Status</span>
          <select
            class="form-select shadow-none text-black border-0 ps-0 pt-0 pb-0 pe-20 fs-14 fw-medium"
          >
            <option selected class="fw-medium">Show All</option>
            <option value="1" class="fw-medium">In Stock</option>
          </select>
        </div> -->
        <router-link
          to="/Reglements"
          class="default-btn text-white fw-medium d-inline-block text-decoration-none transition ps-10 pe-10 pt-5 pb-5"
        >
          Voir la liste
        </router-link>

        <!-- <form>
          <div class="input-group">
            <input
              type="text"
              class="form-control shadow-none fw-medium ps-12 pt-8 pb-8 pe-12 letter-spacing"
              placeholder="Search"
            />
            <button
              class="default-btn position-relative transition border-0 text-white ps-12 pe-12 rounded-1"
              type="button"
            >
              <i class="flaticon-search-interface-symbol position-relative"></i>
            </button>
          </div>
        </form> -->

      </div>
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                #
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Date
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Client
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Montant
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Montant sans Epargne
              </th>
              <!-- <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 pe-0"
              >
                STATUS
              </th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="order in orders" :key="order.id">
              <th class="shadow-none lh-8 fw-bold ps-0">
                <router-link
                  to="/product-details"
                  class="text-decoration-none text-black-emphasis"
                >
                  {{ order.id }}
                </router-link>
              </th>
              <td class="shadow-none lh-1 fw-medium">
                {{ format_Date(order.dateVente) }}
                <!-- <span class="text-body-tertiary"> ago</span> -->
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ '[ '+order.client.code+' ] '+order.client.prenoms+ ' ' + order.client.nom }}
                
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                {{ order.montant }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                {{ (order.montant)? order.montantSansEpargne : '-' }}
              </td>
              <!-- <td class="shadow-none lh-1 fw-medium pe-0">
                <span :class="['badge', order.class]">{{ order.status }}</span>
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import productsOrders from "./productsOrders.json";
import ApiService from "@/services/ApiService";
import { error, format_Date } from "@/utils/utils";
import { Vente } from "@/models/Vente";

export default defineComponent({
  name: "ProductsOrders",
  setup() {

const orders = ref<Array<Vente>>([])

function getAll(page = 1, limi = 10, searchTerm = '') {
    return ApiService.get(`ventes?page=${page}&limit=${limi}&mot=${searchTerm}&`)
    .then(({ data }) => {
      orders.value = data.data.data;
    })
    .catch(({ response }) => {
      error(response.data)
    });
}

onMounted(() => {
  getAll();
});

return {
  orders,
  format_Date
};
  },
});
</script>